export const parseStringToMeaningfulBool = (query) => {
    if (query.toLowerCase() === "yes") {
        return true;
    } else {
        return false;
    }
};
